<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Online Coaching Software by Platforma</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Get a higher LTV from your clients with advanced tools."
      />
    </Head>
  </div>
  <!-- content start -->

  <!-- =======CONTAINER START======== -->

  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
  >
    <!-- ===================== HERO SECTION ===================== -->

    <section
      id="section1"
      class="hero-section mx-auto mt-[150px] gap-1 bg-transparent lg:flex lg:py-0 before:lg:block"
      :style="backgroundImageStyleMain"
    >
      <div
        class="left-0 mt-0 bg-transparent px-[25px] lg:max-w-[438px] xl:px-0"
      >
        <h1
          class="top-full left-0 mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          The #1 Coaching Management Platform.
        </h1>

        <p
          class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
        >
          Streamline your lead process, checkout, and onboarding with
          Platforma's all-in-one coaching management.
        </p>

        <!-- captcher email widget -->

        <EmailCaptureHeaderWidget />

        <img :src="$filters.media_path('/images/stars.svg')" alt="" />
      </div>

      <div class="mb-[30px] mt-[30px] lg:mt-0 z-20 px-[25px]">
        <video
          class="lg:max-w-[648px] lg:mt-[30px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
          id=""
          loop
          muted
          autoplay
          playsinline
        >
          <source
            :src="
              $filters.media_path(
                '/videos/coaching-appointment-scheduler-like-calendly-com.mp4'
              )
            "
            type="video/mp4"
          />
        </video>

        <!-- <img
          loading="lazy"
          class="lg:max-w-[650px]"
          :src="
            $filters.media_path('/images/calendly-style-coaching-scheduler.png')
          "
          alt="Your personal event scheduler to book clients for sales calls."
        /> -->
      </div>
    </section>

    <div
      class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
    >
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      <h2
        class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
      >
        JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
      </h2>
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
    </div>

    <!-- ===================== SELF CENTRALIZED SECTION===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
    >
      <img
        class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
        :src="$filters.media_path('/images/blue_gradient.svg')"
        alt=""
      />

      <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
        <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
          <div
            id="text_video_hosting"
            class="text-xs font-extrabold text-[#2D8CFF]"
          >
            SELF CENTRALIZED
          </div>

          <h2
            class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            One hub for serious entrepreneurs.
          </h2>

          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
          />

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Leveling coaching up by providing one hub to manage everything from
            scheduling to invoicing. It’s your time.
          </p>
        </div>

        <div class="z-30 mt-[25px] xl:mt-0">
          <img
            loading="lazy"
            class="lg:w-[625px]"
            :src="
              $filters.media_path('/images/create-invoices-for-clients.png')
            "
            alt="manage all your invoicing from one place."
          />
        </div>
      </div>
    </section>

    <!-- ===================== WORKFLOW SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[200px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
    >
      <img
        class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
        :src="$filters.media_path('/images/green-diamond-dots-bg.svg')"
        alt=""
      />

      <div
        class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
      >
        <div
          id="text_showcase"
          class="text-xs font-extrabold text-[#27AE60] lg:left-0"
        >
          WORKFLOW
        </div>

        <h2
          class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Level up with advanced file sharing.
        </h2>

        <div class="">
          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
          />
        </div>

        <p
          class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
        >
          Send voice message files, video message files, PDF’s, DOCS, and more
          through encrypted chat.
        </p>
      </div>

      <div
        class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
      >
        <img
          loading="lazy"
          class="lg:w-[600px]"
          :src="
            $filters.media_path(
              '/images/private-encrypted-chat-to-coach-one-on-one.png'
            )
          "
          alt="private encrypted chat that you can use for coaching your clients directly."
        />
      </div>
    </section>

    <!-- ===================== COMMUNICATION SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[150px] lg:flex lg:h-[550px] xl:px-0"
    >
      <img
        class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
        :src="$filters.media_path('/images/platforma_turqoise_diamond_bg.svg')"
        alt=""
      />

      <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
        <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
          <div
            id="text_box_office_sales"
            class="text-xs font-extrabold text-[#49CCF9]"
          >
            COMMUNICATION
          </div>

          <h2
            class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Drop Zoom links and downloads. Just log in.
          </h2>

          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#49CCF9] lg:ml-0"
          />

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Make video calls easier with PlatformaMeetings. Clients only need to
            log into their account on your domain to attend the call. No clunky
            software downloads required.
          </p>
        </div>

        <div class="z-30 mt-[25px] xl:mt-0">
          <img
            loading="lazy"
            class="lg:w-[645px]"
            :src="
              $filters.media_path(
                '/images/conduct-video-calls-with-clients-from-within-their-member-portal.png'
              )
            "
            alt="customer coaching live video calls in HD. Built in, no integrations."
          />
        </div>
      </div>
    </section>
  </div>
  <!-- =======CONTENT END======== -->
  <CtaBlock
    cta-headline="Simplify your coaching and 
close more deals every month."
  />
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    EmailCaptureHeaderWidget,
    CtaBlock
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(42%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
